import React from 'react';

interface CloseIconProps {
  width?: string | number;
  height?: string | number;
  fill?: string;
  size?: string | number;
}

const CloseIcon = ({ width = '24', height = '24', fill = '#BEBEBE' }: CloseIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.40002 18.6538L5.34619 17.6L10.9462 12L5.34619 6.40002L6.40002 5.34619L12 10.9462L17.6 5.34619L18.6538 6.40002L13.0538 12L18.6538 17.6L17.6 18.6538L12 13.0538L6.40002 18.6538Z"
        fill={fill}
      />
    </svg>
  );
};

export default CloseIcon;
